import {EntryScope} from 'shared';

export const getAllEntryScopes = () => {
    return Object.values(EntryScope);
};
